import { daisyUIThemes } from "./dasyui_themes";

const hostToTemplates = {
  "piti-template.firebaseapp.com": {
    templateId: "greenshine",
    theme: daisyUIThemes.light,
  },
  "greenshinemm.com": {
    templateId: "greenshine",
    theme: daisyUIThemes.light,
  },
  "urbanfurnituregroup.com": {
    templateId: "urban",
    theme: daisyUIThemes.light,
  },
  //   localhost: {
  //     templateId: "Beauty Treasure",
  //     theme: daisyUIThemes.light,
  //   },
  // "localhost": {
  //     templateId: "International Academy School",
  //     theme: daisyUIThemes.light,
  // },
  "piti-template.web.app": {
    templateId: "International Academy School",
    theme: daisyUIThemes.light,
  },
};

export default hostToTemplates;
